export default __webpack_public_path__ + "static/media/logo-administra-tus-propiedades.2d5c1c88.svg";